import ChatCpActivity from '~/pages/chat/cp/reducers'

export default {
  ChatCpActivity,
}
